import {
    tss,
} from 'app/tss'

export default tss.withNestedSelectors().create(({
    theme,
}) => {
    return {
        root: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
        },
        header: {
            height: 48,
            '@media print': {
                display: 'none',
            },
            position: 'relative',
            left: 48,
            width: 'calc(100% - 48px)',
        },
        main: {
            display: 'flex',
            height: 'calc(100% - 48px)',
            width: 'calc(100% - 48px)',
            position: 'relative',
            left: 48,
        },
        body: {
            height: `calc(100% - ${theme.spacing(4)})`,
            width: `calc(100% - ${theme.spacing(4)})`,
            position: 'relative',
            overflow: 'auto',
            padding: theme.spacing(2),
            backgroundColor: theme.palette.secondary[100],
            display: 'flex',
            '@media print': {
                padding: 0,
            },
        },
        sidebar: {
            width: 0,
            position: 'relative',
            '@media print': {
                display: 'block',
                position: 'fixed',
                height: '100%',
                left: 0,
                top: -9,
            },
        },
        menu: {
            zIndex: 100,
            width: '48px',
            position: 'absolute',
            top: 0,
            height: '100%',
            background: theme.palette.primary[500],
            '@media print': {
                display: 'none',
            },
        },
    }
})
